import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Stack({ variant = "grid", className, children, as, ...rest }) {
    const Component = as ?? "div";
    return (_jsx(Component, { className: classNames(className, "cvr-stack", {
            "cvr-stack--grid": variant === "grid",
            "cvr-stack--carousel": variant === "carousel",
        }), ...rest, children: children }));
}
